exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-0c954ffc]{position:relative;display:flex;flex-wrap:wrap;flex-direction:column;width:calc(100% - 64px);height:calc(100vh - 80px);min-height:540px;padding:0;margin:0 auto}.container_simulcast[data-v-0c954ffc]{position:relative;display:flex;flex-wrap:wrap;flex-direction:column;width:calc(100% - 64px);height:calc(100vh - 0px);min-height:540px;padding:0;margin:0 auto}@media (max-width: 1140px){.container[data-v-0c954ffc]{width:96%;margin:0 auto;padding:0}}@media (max-width: 600px){.container[data-v-0c954ffc]{position:fixed;z-index:0;width:100%;padding:0;height:100vh}}\n", ""]);

// exports
